function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#4A4A4A"
}, /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke-alt",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M101 57.613c-15.081-6.788-27.21-5.78-53.25 1.03C23.306 65.037 12.955 65.915 0 60.14m101 7.472c-15.081-6.789-27.21-5.781-53.25 1.03C23.306 75.036 12.955 75.913 0 70.138m101 7.264c-15.081-6.788-27.21-5.78-53.25 1.03C23.306 84.826 12.955 85.703 0 79.93"
}), /*#__PURE__*/React.createElement("g", {
  "data-svg-class": "RoomButton-stroke"
}, /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M61.531 41.846a3.879 3.879 0 013.879-3.878c4.202 0 7.09-3.397 7.09-8.049V18.806C72.5 8.695 64.412.5 54.437.5H37.564C27.587.5 19.5 8.695 19.5 18.806V29.92c0 4.447 3.555 8.049 7.938 8.049a4.062 4.062 0 014.061 4.061v7.261c0 .67.533 1.21 1.188 1.21h27.657c.654 0 1.187-.54 1.187-1.21v-7.444z"
})), /*#__PURE__*/React.createElement("circle", {
  "data-svg-class": "RoomButton-stroke",
  cx: 34.5,
  cy: 22.5,
  r: 7
}), /*#__PURE__*/React.createElement("circle", {
  "data-svg-class": "RoomButton-stroke",
  cx: 57.5,
  cy: 22.5,
  r: 7
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M47.246 31.052a1.5 1.5 0 00-2.492 0l-2.757 4.113a1.5 1.5 0 001.246 2.335h5.514a1.5 1.5 0 001.246-2.335l-2.757-4.113z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  strokeLinecap: "square",
  d: "M38.5 49.6v-3.2m4 3.2v-3.2m4 3.2v-3.2m4 3.2v-3.2m4 3.2v-3.2"
}));

function SvgEmergencyCarbonMonoxide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 85,
    viewBox: "0 0 101 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyCarbonMonoxide);
export default __webpack_public_path__ + "static/media/EmergencyCarbonMonoxide.ba6d7016.svg";
export { ForwardRef as ReactComponent };